<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <div>
        <span class="font-weight-medium py-2 flex-shrink-0">
          จัดการกลุ่มสิทธิ์
        </span>
        <v-btn
          @click="handleCheckPermission"
          class="mx-4"
          outlined
          :disabled="uiCtrl && !uiCtrl.isEnable('btn:::authority_check:list')"
        >
          <v-icon left>mdi-lightbulb-on-outline</v-icon>
          ตรวจสอบสิทธิ์
        </v-btn>
      </div>
      <v-scroll-x-transition>
        <div class="d-flex align-center" v-show="!accessAuthorityFormShow">
          <div>
            <v-btn
              v-if="isWaitSync"
              color="warning"
              outlined
              class="text-capitalize"
              @click="handleWaitSyncAction"
            >
              {{ loadingWaitSync ? 'Loading...' : 'Wait Sync' }}
            </v-btn>
          </div>
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            class="search-field"
          ></v-text-field>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::authority:create')"
            style="margin-top: 1px"
            color="primary"
            @click="handleAddAccessAuthorityForm"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มกลุ่มสิทธิ์
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      :search="search"
      :headers="headers"
      :items="accessAuthorities"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
      must-sort
    >
      <template v-slot:item.timezone="{ item }">
        <span class="mr-2">
          {{
            item.timezone && item.timezone.timezone_code
              ? item.timezone.timezone_code
              : '-'
          }}
          -
          {{
            item.timezone && item.timezone.title_th
              ? item.timezone.title_th
              : '-'
          }}
        </span>
      </template>
      <template v-slot:item.access_control_start_time="{ item }">
        <div>{{ item.access_control_start_time | formatDate }}</div>
      </template>
      <template v-slot:item.access_control_end_time="{ item }">
        <div>{{ item.access_control_end_time | formatDate }}</div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          @click.stop="onDelete(item)"
          class="action-btn"
          outlined
          x-small
          fab
          color="error lighten-1"
          :disabled="uiCtrl && !uiCtrl.isEnable('btn:::authority:delete')"
        >
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="confirmDeleteAuthority.show" persistent width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          ยืนยันการลบ
        </v-card-title>

        <v-card-text class="py-4">
          <p class="delete-confirm-text">
            คุณต้องการลบกลุ่มสิทธิ์ ?
            <span class="red--text">{{ confirmDeleteAuthority.code }}</span>
          </p>
          <ul class="red--text">
            <li>
              หากคุณลบกลุ่มสิทธิ์นี้ ข้อมูลทั้งหมดที่เกี่ยวข้องจะถูกลบด้วย
            </li>
          </ul>
          <p class="mt-4">
            หากต้องการลบกลุ่มสิทธิ์นี้ กรุณาพิมพ์
            <span class="delete-keyword">delete</span>
          </p>
          <v-text-field
            v-model="confirmDeleteAuthority.verification"
            dense
            outlined
            :disabled="confirmDeleteAuthority.loading"
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            @click="cancelConfirmDeleteAuthority"
            :disabled="confirmDeleteAuthority.loading"
            >ยกเลิก</v-btn
          >
          <v-btn
            depressed
            color="error"
            :disabled="confirmDeleteAuthority.verification !== 'delete'"
            :loading="confirmDeleteAuthority.loading"
            @click="submitConfirmDeleteAuthority"
            >ลบ</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCheckPermissions" width="90%" scrollable>
      <v-card>
        <v-card-title
          class="grey lighten-2 d-flex justify-space-between align-center"
        >
          <div>
            <v-icon class="mr-4">mdi-lightbulb-on-outline</v-icon>
            <span>ตรวจสอบสิทธิ์</span>
          </div>
          <div>
            <v-btn icon @click="dialogCheckPermissions = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="pa-0 check-permission-dialog-content">
          <v-tabs v-model="tabCheckPermissions" show-arrows>
            <v-tab class="text-capitalize">รายการ Device</v-tab>
            <v-tab>รายชื่อพนักงาน</v-tab>
            <v-tab class="text-capitalize">กลุ่มสิทธิ์ Device</v-tab>
            <v-tab>กลุ่มสิทธิ์พนักงาน</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabCheckPermissions">
            <v-tab-item class="pa-4">
              <AuthorityHardwareSummaryList
                :dialogCheckPermissions="dialogCheckPermissions"
              />
            </v-tab-item>
            <v-tab-item class="pa-4">
              <AuthorityEmployeeSummaryList
                :dialogCheckPermissions="dialogCheckPermissions"
              />
            </v-tab-item>
            <v-tab-item class="pa-4">
              <AuthorityHardwareInAuthorityList
                :dialogCheckPermissions="dialogCheckPermissions"
              />
            </v-tab-item>
            <v-tab-item class="pa-4">
              <AuthorityEmployeeInAuthorityList
                :dialogCheckPermissions="dialogCheckPermissions"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
    <AccessAuthorityForm
      :formShow="accessAuthorityFormShow"
      :formAction="accessAuthorityFormAction"
      :accessAuthority="accessAuthority"
      :accessAuthorityInit="accessAuthorityInit"
      @isAccessAuthorityDataChange="handleAccessAuthorityFormDataChange"
      @formActionCompleted="handleAccessAuthorityFormActionCompleted"
      @onReset="handleAccessAuthorityFormReset"
      @onAddDevice="handleAccessAuthorityOnAddDevice"
      @onAddEmployee="handleAccessAuthorityOnAddEmployee"
    />
    <AccessAuthorityAddDevice
      :formShow="accessAuthorityAddDeviceFormShow"
      :accessAuthority="accessAuthority"
      :accessAuthorityInit="accessAuthorityInit"
      @isAccessAuthorityDataChange="handleAccessAuthorityFormDataChange"
      @formActionCompleted="handleAccessAuthorityFormActionCompleted"
      @onReset="handleAccessAuthorityFormReset"
      @onClickBack="() => (accessAuthorityAddDeviceFormShow = false)"
    />
    <AccessAuthorityAddEmployee
      :formShow="accessAuthorityAddEmployeeFormShow"
      :accessAuthority="accessAuthority"
      :accessAuthorityInit="accessAuthorityInit"
      @isAccessAuthorityDataChange="handleAccessAuthorityFormDataChange"
      @formActionCompleted="handleAccessAuthorityFormActionCompleted"
      @onReset="handleAccessAuthorityFormReset"
      @onClickBack="() => (accessAuthorityAddEmployeeFormShow = false)"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="
        accessAuthorityAddDeviceFormShow ||
        accessAuthorityAddEmployeeFormShow ||
        accessAuthorityFormAction === 'add'
      "
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
    <v-dialog v-model="dialogWaitSyncConfirm" persistent max-width="480">
      <v-card>
        <v-card-title class="text-h5">
          ยืนยันการ Sync ข้อมูลทั้งหมด
        </v-card-title>
        <v-card-text>
          จำนวน Device ที่จะ Sync {{ waitSyncData.length }} เครื่อง
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="loadingWaitSync"
            text
            @click="dialogWaitSyncConfirm = false"
          >
            ยกเลิก
          </v-btn>
          <v-btn
            :loading="loadingWaitSync"
            color="primary"
            text
            @click="handleSubmitConfirmWaitSync"
          >
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import AuthorityEmployeeInAuthorityList from '@/components/AuthorityEmployeeInAuthorityList.vue'
import AuthorityEmployeeSummaryList from '@/components/AuthorityEmployeeSummaryList.vue'
import AuthorityHardwareInAuthorityList from '@/components/AuthorityHardwareInAuthorityList.vue'
import AuthorityHardwareSummaryList from '@/components/AuthorityHardwareSummaryList.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import AccessAuthorityAddDevice from '@/views/access-authority/AccessAuthorityAddDevice.vue'
import AccessAuthorityAddEmployee from '@/views/access-authority/AccessAuthorityAddEmployee.vue'
import AccessAuthorityForm from '@/views/access-authority/AccessAuthorityForm.vue'

export default {
  components: {
    ConfirmDialog,
    AccessAuthorityForm,
    AccessAuthorityAddDevice,
    AccessAuthorityAddEmployee,
    AuthorityHardwareSummaryList,
    AuthorityEmployeeSummaryList,
    AuthorityEmployeeInAuthorityList,
    AuthorityHardwareInAuthorityList,
  },
  data() {
    return {
      dialogWaitSyncConfirm: false,
      loadingWaitSync: false,
      isWaitSync: false,
      waitSyncData: [],
      confirmDeleteAuthority: {
        show: false,
        loading: false,
        code: '',
        verification: '',
        data: null,
      },
      tabCheckPermissions: null,
      dialogCheckPermissions: false,
      dialogForbidden: false,
      sortBy: ['authority_code'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      headers: [
        {
          text: 'รหัสกลุ่มสิทธิ์',
          align: 'start',
          value: 'authority_code',
          width: '10%',
        },
        { text: 'คำอธิบาย (ไทย)', value: 'title_th', width: '20%' },
        { text: 'รหัสช่วงเวลา', value: 'timezone', width: '20%' },
        {
          text: 'จำนวน Device',
          value: 'total_authority_hardware',
          width: '10%',
        },
        {
          text: 'จำนวนพนักงาน',
          value: 'total_authority_employee',
          width: '10%',
        },
        {
          text: 'วันเริ่มใช้งาน',
          value: 'access_control_start_time',
          width: '10%',
        },
        {
          text: 'วันสิ้นสุดใช้งาน',
          value: 'access_control_end_time',
          width: '10%',
        },
        { text: 'ดำเนินการ', value: 'actions', width: '10%', sortable: false },
      ],
      accessAuthorityFormShow: false,
      accessAuthorityAddDeviceFormShow: false,
      accessAuthorityAddEmployeeFormShow: false,
      accessAuthorityFormAction: '',
      accessAuthority: {
        timezone: {},
      },
      accessAuthorityInit: {
        timezone: {},
      },
      isAccessAuthorityDataChange: false,
      timeout: null,
    }
  },
  filters: {
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : ''
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    accessAuthorities() {
      return this.$store.state.accessAuthority.accessAuthorities
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'การจัดการ กลุ่มสิทธิ์',
        disabled: true,
      },
    ])

    this.loadData()

    try {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        params: {
          company_uuid,
          dpc: 'access-authority-to-list-hardware',
        },
      }

      this.loadingWaitSync = true

      const response = await this.fetchHardwaresSyncAll(payload)
      this.waitSyncData = response.filter((h) => {
        return (
          h.is_sync_pending &&
          h.is_connected &&
          h.sync_status.is_sync_process === false
        )
      })
      this.isWaitSync = this.waitSyncData.length > 0 ? true : false
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.loadingWaitSync = false
    }
  },
  methods: {
    ...mapActions({
      fetchAccessAuthorities: 'accessAuthority/fetchAccessAuthorities',
      deleteAccessAuthority: 'accessAuthority/deleteAccessAuthority',
      deleteAuthorityDeviceMember:
        'accessAuthority/deleteAuthorityDeviceMember',
      deleteAuthorityEmployeeMember:
        'accessAuthority/deleteAuthorityEmployeeMember',
      fetchHardwaresSyncAll: 'hardware/fetchHardwaresSyncAll',
      getLastUpdate: 'hardware/getLastUpdate',
    }),
    resetAccessAuthority() {
      this.accessAuthority = { timezone: {} }
      this.accessAuthorityInit = { timezone: {} }
    },
    normalizeAccessAuthority(authority) {
      return {
        ...authority,
        access_control_start_time: authority.access_control_start_time
          ? new Date(authority.access_control_start_time)
          : '',
        access_control_end_time: authority.access_control_end_time
          ? new Date(authority.access_control_end_time)
          : '',
        timezone: { ...authority.timezone },
      }
    },
    async handleWaitSyncAction() {
      try {
        const { company_uuid } = this.$store.state.authentication.company
        const payload = {
          params: {
            company_uuid,
            dpc: 'access-authority-to-list-hardware',
          },
        }
        this.$store.commit('SET_LOADING', true)
        const response = await this.fetchHardwaresSyncAll(payload)

        const items = response.filter((h) => {
          return (
            h.is_sync_pending &&
            h.is_connected &&
            h.sync_status.is_sync_process === false
          )
        })

        if (items.length === 0) {
          this.isWaitSync = false
          this.waitSyncData = []

          const snackbar = {
            show: true,
            color: 'warning',
            timeout: 4000,
            message: 'ไม่มี Device ที่จะ Sync',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)
          return
        }

        this.waitSyncData = items
        this.dialogWaitSyncConfirm = true
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.commit('SET_LOADING', false)
      }
    },
    async handleSubmitConfirmWaitSync() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.loadingWaitSync = true
        let skippedCount = 0

        for (const item of this.waitSyncData) {
          const hardwareModelCode =
            item &&
            item.hardware_model &&
            item.hardware_model.hardware_model_code
          const hardwareUuid = item && item.hardware_uuid

          if (!hardwareModelCode || !hardwareUuid) {
            skippedCount += 1
            continue
          }

          await this.getLastUpdate({
            company_uuid,
            hardware_model: hardwareModelCode,
            body: {
              hardware_uuid: hardwareUuid,
              data: null,
            },
          })
        }

        this.waitSyncData = []
        this.isWaitSync = false

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message:
            skippedCount > 0
              ? `ส่งคำสั่งเรียบร้อยแล้ว (ข้าม ${skippedCount} Device เพราะข้อมูลไม่ครบ)`
              : 'ส่งคำสั่งเรียบร้อยแล้ว',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loadingWaitSync = false
        this.dialogWaitSyncConfirm = false
      }
    },
    onDelete(item) {
      this.confirmDeleteAuthority = {
        ...this.confirmDeleteAuthority,
        show: true,
        code: `${item.authority_code} - ${item.title_th}`,
        data: item,
      }
    },
    cancelConfirmDeleteAuthority() {
      this.confirmDeleteAuthority = {
        ...this.confirmDeleteAuthority,
        show: false,
        code: '',
        verification: '',
        data: null,
      }
    },
    async submitConfirmDeleteAuthority() {
      try {
        this.confirmDeleteAuthority.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const deleteList = []
        if (this.confirmDeleteAuthority.data.total_authority_hardware > 0) {
          deleteList.push(
            this.deleteAuthorityDeviceMember({
              company_uuid,
              authority_uuid: this.confirmDeleteAuthority.data.authority_uuid,
              body: {
                clear_all: true,
              },
            })
          )
        }
        if (this.confirmDeleteAuthority.data.total_authority_employee > 0) {
          deleteList.push(
            this.deleteAuthorityEmployeeMember({
              company_uuid,
              authority_uuid: this.confirmDeleteAuthority.data.authority_uuid,
              body: {
                clear_all: true,
              },
            })
          )
        }

        if (deleteList.length > 0) {
          await Promise.all(deleteList)
        }

        const payload = {
          company_uuid,
          authority_uuid: this.confirmDeleteAuthority.data.authority_uuid,
        }

        await this.deleteAccessAuthority(payload)

        this.confirmDeleteAuthority = {
          ...this.confirmDeleteAuthority,
          show: false,
          loading: false,
          code: '',
          verification: '',
          data: null,
        }

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        this.confirmDeleteAuthority.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleAccessAuthorityOnAddDevice() {
      this.accessAuthorityAddDeviceFormShow = true
    },
    handleAccessAuthorityOnAddEmployee() {
      this.accessAuthorityAddEmployeeFormShow = true
    },
    handleCheckPermission() {
      this.dialogCheckPermissions = true
    },
    classRowSelected(row) {
      if (this.accessAuthority.authority_uuid === row.authority_uuid) {
        return 'row-selected'
      }
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::authority:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.accessAuthority.authority_uuid === row.authority_uuid) {
        this.accessAuthorityFormShow = false
        this.accessAuthorityFormAction = ''
        this.accessAuthority = {
          timezone: {},
        }
        this.accessAuthorityInit = {
          timezone: {},
        }
      } else {
        this.accessAuthorityFormShow = true
        this.accessAuthorityFormAction = 'edit'
        this.accessAuthority = {
          ...this.normalizeAccessAuthority(row),
        }
        this.accessAuthorityInit = {
          ...this.normalizeAccessAuthority(row),
        }
      }
    },
    handleRowSelected(row) {
      if (this.isAccessAuthorityDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddAccessAuthorityForm() {
      this.accessAuthorityFormShow = true
      this.accessAuthorityFormAction = 'add'
      this.accessAuthority = {
        timezone: {},
      }
      this.accessAuthorityInit = {
        timezone: {},
      }
    },
    handleAccessAuthorityFormDataChange(value) {
      this.isAccessAuthorityDataChange = value
    },
    handleAccessAuthorityFormReset() {
      this.accessAuthorityFormShow = false
      this.accessAuthorityFormAction = ''
      this.accessAuthority = {
        timezone: {},
      }
      this.accessAuthorityInit = {
        timezone: {},
      }
      this.isAccessAuthorityDataChange = false
    },
    async handleAccessAuthorityFormActionCompleted({
      formAction,
      formType,
      accessAuthority,
    }) {
      const needsUpdate = [
        'add',
        'edit',
        'addDevice',
        'addEmployee',
        'deviceOrEmployeeDelete',
        'deviceOrEmployeeDeleteAll',
      ]

      if (needsUpdate.includes(formAction) && accessAuthority) {
        const normalized = this.normalizeAccessAuthority(accessAuthority)
        this.accessAuthority = normalized
        this.accessAuthorityInit = normalized
      }

      if (formAction === 'delete' && formType === 'accessAuthorityForm') {
        this.resetAccessAuthority()
        this.accessAuthorityFormShow = false
        this.accessAuthorityFormAction = ''
      }

      // handle wait sync
      try {
        const { company_uuid } = this.$store.state.authentication.company
        const payload = {
          params: {
            company_uuid,
            dpc: 'access-authority-to-list-hardware',
          },
        }

        this.isWaitSync = true
        this.loadingWaitSync = true

        const response = await this.fetchHardwaresSyncAll(payload)

        const items = response.filter((h) => {
          return (
            h.is_sync_pending &&
            h.is_connected &&
            h.sync_status.is_sync_process === false
          )
        })

        if (items.length === 0) {
          this.isWaitSync = false
          this.loadingWaitSync = false
          this.waitSyncData = []

          return
        }

        this.loadingWaitSync = false
        this.waitSyncData = items

        this.dialogWaitSyncConfirm = true
      } catch (error) {
        this.loadingWaitSync = false
        this.isWaitSync = false
        this.waitSyncData = []

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async loadData() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
        }

        await this.fetchAccessAuthorities(payload)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loading = false
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.accessAuthorityFormShow = false
      this.accessAuthorityAddDeviceFormShow = false
      this.accessAuthorityAddEmployeeFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isAccessAuthorityDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>

<style scoped>
.search-field {
  width: 200px;
  padding: 0 5px;
}
.delete-confirm-text {
  font-size: 16px;
}
.delete-keyword {
  font-size: 16px;
  font-weight: bold;
}
.check-permission-dialog-content {
  height: 90vh;
}
.action-btn {
  width: 26px;
  height: 26px;
}
</style>
